<div class="vehicle-card" [class.with-selector]="isParentVehicleCard && selectable" [class.no-card-style]="noCardStyle" [class.disabled]="disabled">
  <!-- Vehicle Header -->
  <div class="vehicle-header">
    <div class="vehicle-title">
      <!-- Selection control next to vehicle name -->
      <div class="vehicle-selector" *ngIf="isParentVehicleCard && selectable">
        <label class="selector-wrapper">
          <input
            [type]="selectionType"
            class="selector-input"
            [name]="selectionName"
            [checked]="selected"
            (change)="onSelectionChange($event)"
          />
          <span class="selector-custom"></span>
        </label>
      </div>
      <p class="p2 text-medium m-0">{{ vehicle.name }}</p>
    </div>
    <div class="vehicle-actions">
      <!-- Desktop/Tablet: Show individual action buttons -->
      <div class="desktop-actions">
        <button class="action-btn" (click)="onEdit()" [disabled]="disabled">
          <img src="assets/images/vehicle/edit-icon.svg" alt="Edit vehicle">
        </button>
        <button class="action-btn" (click)="onDelete()" [disabled]="disabled" *ngIf="showDeleteButton">
          <img src="assets/images/vehicle/delete-icon.svg" alt="Delete vehicle">
        </button>
      </div>
      
      <!-- Mobile: Show three-dot menu (only when useMobileMenu is true) -->
      <div  class="mobile-actions">
        <button class="mobile-menu-btn" (click)="toggleMobileMenu($event)" [class.active]="showMobileMenu">
          <svg width="18" height="4" viewBox="0 0 18 4" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 2C1 2.26522 1.10536 2.51957 1.29289 2.70711C1.48043 2.89464 1.73478 3 2 3C2.26522 3 2.51957 2.89464 2.70711 2.70711C2.89464 2.51957 3 2.26522 3 2C3 1.73478 2.89464 1.48043 2.70711 1.29289C2.51957 1.10536 2.26522 1 2 1C1.73478 1 1.48043 1.10536 1.29289 1.29289C1.10536 1.48043 1 1.73478 1 2ZM8 2C8 2.26522 8.10536 2.51957 8.29289 2.70711C8.48043 2.89464 8.73478 3 9 3C9.26522 3 9.51957 2.89464 9.70711 2.70711C9.89464 2.51957 10 2.26522 10 2C10 1.73478 9.89464 1.48043 9.70711 1.29289C9.51957 1.10536 9.26522 1 9 1C8.73478 1 8.48043 1.10536 8.29289 1.29289C8.10536 1.48043 8 1.73478 8 2ZM15 2C15 2.26522 15.1054 2.51957 15.2929 2.70711C15.4804 2.89464 15.7348 3 16 3C16.2652 3 16.5196 2.89464 16.7071 2.70711C16.8946 2.51957 17 2.26522 17 2C17 1.73478 16.8946 1.48043 16.7071 1.29289C16.5196 1.10536 16.2652 1 16 1C15.7348 1 15.4804 1.10536 15.2929 1.29289C15.1054 1.48043 15 1.73478 15 2Z" stroke="#555963" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            
        </button>
        
        <!-- Mobile Menu Dropdown -->
        <div class="mobile-menu-dropdown" *ngIf="showMobileMenu" (click)="$event.stopPropagation()">
          <div class="mobile-menu-item" (click)="onMobileEdit()">
            <svg class="menu-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M11.3333 2.00001C11.5084 1.8249 11.7163 1.686 11.9453 1.59128C12.1742 1.49657 12.4191 1.44775 12.6667 1.44775C12.9142 1.44775 13.1591 1.49657 13.3881 1.59128C13.617 1.686 13.8249 1.8249 14 2.00001C14.1751 2.17512 14.314 2.38302 14.4087 2.61197C14.5034 2.84092 14.5522 3.0858 14.5522 3.33334C14.5522 3.58088 14.5034 3.82576 14.4087 4.05471C14.314 4.28366 14.1751 4.49156 14 4.66667L5 13.6667L1.33333 14.6667L2.33333 11L11.3333 2.00001Z" stroke="#555A63" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Edit</span>
          </div>
          <div *ngIf="showDeleteButton" class="mobile-menu-item delete-item" (click)="onMobileDelete()">
            <svg class="menu-icon" width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M2 4H3.33333H14" stroke="#555963" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M5.33333 4V2.66667C5.33333 2.31305 5.47381 1.97391 5.72386 1.72386C5.97391 1.47381 6.31305 1.33334 6.66667 1.33334H9.33333C9.68696 1.33334 10.0261 1.47381 10.2761 1.72386C10.5262 1.97391 10.6667 2.31305 10.6667 2.66667V4M12.6667 4V13.3333C12.6667 13.687 12.5262 14.0261 12.2761 14.2761C12.0261 14.5262 11.687 14.6667 11.3333 14.6667H4.66667C4.31305 14.6667 3.97391 14.5262 3.72386 14.2761C3.47381 14.0261 3.33333 13.687 3.33333 13.3333V4H12.6667Z" stroke="#555963" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M6.66667 7.33334V11.3333" stroke="#555963" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
              <path d="M9.33333 7.33334V11.3333" stroke="#555963" stroke-width="1.33333" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <span>Delete</span>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Vehicle Details -->
  <div class="vehicle-details">
    <div class="detail-item">
      <div class="detail-label p7 text-medium">LICENSE PLATE</div>
      <div class="detail-value">{{ vehicle.licensePlate }}</div>
    </div>
    <div class="detail-item">
      <div class="detail-label">VIN</div>
      <div class="detail-value">{{ vehicle.vin }}</div>
    </div>
  </div>

  <!-- Family Plan Status -->
  <div class="family-plan-status" *ngIf="showFamilyPlanStatus">
    <div class="detail-label">FAMILY PLAN VEHICLE</div>
    <div class="detail-value">{{ vehicle.isFamilyPlanVehicle ? 'Yes' : 'No' }}</div>
  </div>
</div>
